module.exports = __webpack_public_path__ + "img/c04_unitstartechfortifiedtower_Normal_ua.0276e018.webp";